export const signIn = () => {
  return {
    type: 'SIGN_IN',
  };
};

export const addToken = (token) => {
  return {
    type: 'ADD_TOKEN',
    token,
  };
};

export const removeToken = () => {
  return { type: 'REMOVE_TOKEN' };
};
